import { mapDeviceModelFromSysApi } from '@shure/cloud/device-management/devices/data-access';
import { DeviceDetection } from '@shure/cloud/shared/models/devices';
import { DeviceStatus } from '@shure/shared/angular/data-access/system-api/models';
import { DeviceNameCellData } from '@shure/shared/angular/ui/components/ag-grid-next';

export interface LocalNetworkTableRowData {
	id: string;
	nameCellData: DeviceNameCellData;
	model: string;
	ipAddress: string;
	firmwareVersion: string;
	macAddress: string;
}

export function mapDeviceDetectionDataToLocalNetworkTableRowData(
	devices: DeviceDetection[]
): LocalNetworkTableRowData[] {
	return devices.map((d) => mapDeviceDetectionToLocalNetworkTableRowData(d));
}

function mapDeviceDetectionToLocalNetworkTableRowData(device: DeviceDetection): LocalNetworkTableRowData {
	// for nameCellData, only the id, name and model matter here since we don't have the other ones in our device in this case
	const nameCellData: DeviceNameCellData = {
		id: device.device.id,
		model: mapDeviceModelFromSysApi(device.device.model),
		status: DeviceStatus.Discovered,
		isVirtual: false,
		isPasswordEnabled: false,
		isAuthenticated: false,
		name: {
			name: device.device.name,
			isDisabled: false
		}
	};

	const rowData: LocalNetworkTableRowData = {
		id: device.device.id,
		nameCellData,
		model: device.device.model,
		ipAddress: device.device.ipAddress,
		firmwareVersion: device.device.firmwareVersion,
		macAddress: device.device.macAddress
	};

	return rowData;
}
